import { $ABTest } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';
import _get from 'lodash/get';

export const $UseCommentMoreRepliesCTA = atom((get) => {
  const { parameters } = get($ABTest);

  if ((__BUILD_TYPE__ as any) === 'local_dev') {
    return true;
  }

  return Boolean(_get(parameters, ['web', 'comment_more_replies_cta'], false));
});

export const $UseVideoPlayBtnCTA = atom((get) => {
  const { parameters } = get($ABTest);

  if ((__BUILD_TYPE__ as any) === 'local_dev') {
    return true;
  }

  return Boolean(_get(parameters, ['web', 'related_post_video_btn_cta'], false));
});
